// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"CalculatorLayout_layoutWrapper__-M4ub","content":"CalculatorLayout_content__RPvWn"};